import { createAction, props } from '@ngrx/store';

const feature = '[Crash Report Approval]';

export const approveCrashReport = createAction(`${feature} Approve Crash Report`);
export const crashReportApproved = createAction(`${feature} Crash Report Approved`);

export const rejectCrashReport = createAction(`${feature} Reject Crash Report`, props<{ comment: string }>());
export const crashReportRejected = createAction(`${feature} Crash Report Rejected`);
